import {ErrorState} from '../reducers/error.reducer';
import {AlertsState} from '../reducers/alerts.reducer';
import {safelyToJS} from './utils';

export * from './influencer.selectors';
export * from './user.selectors';
export * from './gamesSelector';
export * from './eula.selectors';
export * from './tax.selectors';
export * from './config.selectors';
export * from './news.selectors';
export * from './payout.selectors';
export * from './oauth.selectors';
export * from './settings.selectors';
export * from './overview.selectors';
export * from './page.selectors';
export * from './dashboard.selectors';

export const selectMessages = (state): Record<string, string> =>
    state.get('localization').get('messageProperties');

export const selectLocale = state => state.getIn(['localization', 'locale']);

export const selectError = (state): ErrorState => state.get('error').toJS();

export const selectAlerts = (state): AlertsState => state.get('alerts').toJS();

export const selectAlertsLength = (state): number =>
    safelyToJS(state.getIn(['alerts', 'alerts'])).length;

export const selectAlertsLoading = (state): boolean => state.getIn(['alerts', 'loading']);
